"use client"

import { PriceView, priceView as priceViewAtom } from "@/app/price"
import { Trans } from "@lingui/react/macro"
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useCallback } from "react"

export const PriceViewSelector = reatomComponent(() => {
  const currentPriceView = priceViewAtom() // Direct call to global atom

  const onChange = useCallback((value: string) => {
    if (value) {
      priceViewAtom.set(value as PriceView)
    }
  }, [])

  return (
    <ToggleGroup
      type="single"
      value={currentPriceView}
      onValueChange={onChange}
      data-testid="price-view-selector"
    >
      <ToggleGroupItem key={PriceView.USD} value={PriceView.USD}>
        USD
      </ToggleGroupItem>
      <ToggleGroupItem
        className="min-w-[60px]"
        key={PriceView.NATIVE_CRYPTO}
        value={PriceView.NATIVE_CRYPTO}
      >
        <Trans>Crypto</Trans>
      </ToggleGroupItem>
    </ToggleGroup>
  )
}, "PriceViewSelector")
